import React from 'react';

const About = () => {
  return (
    <div name='about' className='w-full h-screen bg-[#0a192f] text-gray-300'>
      <div className='flex flex-col justify-center items-center w-full h-full'>
        <div className='max-w-[1000px] w-full grid grid-cols-2 gap-8'>
          <div className='sm:text-right pb-8 pl-4'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
              About
            </p>
          </div>
          <div></div>
          </div>
          <div className='max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p>Hi, I'm Anmol Gulati</p>
              <p>Nice to meet you!</p>
            </div>
            <div>
              <p>I'm a Silicon Valley based Software Engineer & UW Madison student 
                creating innovative AI and Machine Learning solutions for a digital world, 
                driven by a strong desire to push technological boundaries. I'm passionate about building 
                excellent software that improves the lives around me. Beyond my work, I channel my drive for 
                excellence both physically and intellectually through my passion for bodybuilding. </p>  
            </div>
          </div>
      </div>
    </div>
  );
};

export default About;
